import PrivacyPolicyCard from './PrivacyPolicyCard';
export default PrivacyPolicyCard;
